import React from "react";

export function StatusBadge({ status }) {
    const s = (status || "").toLowerCase();
    const map = {
        pending:   "bg-amber-500/15 text-amber-300 border-amber-500/30",
        approved:  "bg-emerald-500/15 text-emerald-300 border-emerald-500/30",
        canceled:  "bg-red-500/15 text-red-300 border-red-500/30",
        cancelled: "bg-red-500/15 text-red-300 border-red-500/30",
        rejected:  "bg-red-500/15 text-red-300 border-red-500/30",
        "no-show": "bg-white/10 text-white/60 border-white/20",
    };
    return (
        <span
            className={`inline-flex text-[10px] uppercase tracking-[0.18em] px-2 py-1 rounded-full border ${map[s] || "bg-white/10 text-white/60 border-white/20"}`}
            data-testid={`status-${s || "unknown"}`}
        >
            {status || "—"}
        </span>
    );
}

export default StatusBadge;
